import React, { useEffect, useState, useRef } from "react";

import { Notification } from "@vds/notifications";
import { Loader } from "@vds/loaders";
import { connect, useSelector } from "react-redux";
import * as Actions from "../../store/actions/cases/allCasesActions";

import styled from "styled-components";
import { Body } from "@vds/typography";
import Tick from "../../assets/icons/tickSymbol.png";
import Caution from "../../assets/icons/caution.png";
import * as CreateCaseActions from "../../store/actions/cases/createCaseActions";
import * as viewCaseDetailsActions from "../../store/actions/cases/viewCaseDetailsActions";
import * as CaseAttachemntCall from "../../api/cases/index";

import { useTranslation } from "react-i18next";
import { CPButton, CustomLoader } from "../../constants/common/StyledGlobalConstants";
import { pendoTrack } from "../../util/pendoUtil";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import AttachmentInput from "./AttachmentInput";
import RedesignedModal from "../common/RedesignedModal";
import CPIcon from "../../pages/Login/CPIcon";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

const FilenameRegex = /^[a-zA-Z0-9!_.'()-]*$/;

export const CustomisedTextLink = styled.span`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  width: ${(props) => (props.width ? props.width : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  color: #0077b4;
  border-bottom: 1px solid #0077b4;
  &:hover {
    border-bottom: 2px solid #0077b4;
  }
  &:active {
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;

const ButtonWrapper = styled.div`
  justify-content: flex-end;
  position: sticky;
  bottom: -1px;
  background: white;
  padding-top: 24px;
  display: flex;
  z-index: 1000;
  padding-bottom: 2px;
`;

const Wrapper = styled.div`
  display: ${(props) => (props.display ? props.display : "")};
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "")};
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : "")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  background: ${(props) => (props.background ? props.background : "")};
  color: ${(props) => (props.fontColor ? props.fontColor : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  height: ${(props) => (props.height ? props.height : "")};
  width: ${(props) => (props.width ? props.width : "")};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "")};
  padding-top: ${(props) => props.paddingTop};
  gap: ${(props) => props.gap};
`;

const CustomisedFileNames = styled.span`
  overflow-wrap: anywhere;
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  display: inline;
  text-decoration: underline;
  line-height: 14px;
  color: #0077b4;
  border-color: #0077b4;
  text-underline-offset: 4px;
  &:hover {
    text-decoration: underline 2px;
  }
  &:focused {
    box-outline: "2px #0077B4";
  }
`;
const StyledRemoveIcon = styled.img`
  width: 1rem;
  height: 1.2rem;
  position: relative;
  top: 5px;
  left: 0.625rem;
  cursor: pointer;
`;

const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding: ${(props) => (props.padding ? props.padding : "0")};
`;

let validFilesList = [".pdf", ".doc", ".docx", ".ppt", ".pptx", ".xls", ".xlsx", ".txt", "jpg", ".jpeg", "png"];
let FileCount = 0;

const AddAttachmentImpl = (props) => {
  const [fileInfos, setFileInfos] = useState([]);
  const [allFilePostData, setAllFilePostData] = useState([]);
  const [commentAllFilePostData, setCommentAllFilePostData] = useState([]);
  const [attachmentLoaderSmall, setAttachmentLoaderSmall] = useState(false);
  const [fileUploadFailedAlert, setFileUploadFailedAlert] = useState(false);
  const [fileStatusResponse, setFileStatusResponse] = useState([]);
  const [fileSuccessAndError, setFileSuccessAndError] = useState([]);
  const [removableFiles, setRemovableFiles] = useState([]);
  const [removableExtensionFiles, setRemovableExtensionFiles] = useState([]);
  const [modalClose, setModalClose] = useState(false);
  const [isFileLimitReached, setIsFileLimitReached] = useState(false);
  const [fileExtensionModal, setFileExtensionModal] = useState(false);
  const inputRef = useRef();
  const attachLinkRef = useRef(null);
  const filenameRef = useRef(null);

  const { t } = useTranslation("casesTranslation");

  const { userLanguage } = useSelector((state) => state.ACCOUNT);

  useEffect(() => {
    props.isResetAttachedFiles && onClickOfCancel();
  }, [props.isResetAttachedFiles]);

  useEffect(() => {
    if (props.handleAttachemntSubmit === true) {
      handleFilePostData();
    }
  }, [props.handleAttachemntSubmit]);

  useEffect(() => {
    if (props.handleCommentAttachmentSubmit === true && commentAllFilePostData.length !== 0) {
      handleGlobalCommentAttachments();
    } else if (props.handleCommentAttachmentSubmit === true && commentAllFilePostData.length === 0) {
      handleCommentModalClose();
    }
  }, [props.handleCommentAttachmentSubmit]);

  useEffect(() => {
    if (allFilePostData) {
      handleGlobalAttachments();
    }
  }, [allFilePostData]);

  useEffect(() => {
    if (commentAllFilePostData) {
      handleCommentAttachments();
    }
  }, [commentAllFilePostData]);

  useEffect(() => {
    FileCount = 0;
  }, []);

  useEffect(() => {
    if (removableFiles.length) {
      setModalClose(true);
      props.addComments === true
        ? pendoTrack("Customer Portal | Support Cases | Add Comments | Maximum File Size", {
            status: "Invalid File Size",
            accountId: props.accountNumber,
          })
        : pendoTrack("Customer Portal | Support Cases | Create New Case | Maximum File Size", {
            status: "Invalid File Size",
            accountId: props.accountNumber,
          });
    } else {
      setModalClose(false);
    }
  }, [removableFiles]);

  useEffect(() => {
    if (removableExtensionFiles.length) {
      setFileExtensionModal(true);
      props.addComments === true
        ? pendoTrack("Customer Portal | Support Cases | Add Comments | Invaid File Extention", {
            status: "Invalid File Extention",
            accountId: props.accountNumber,
          })
        : pendoTrack("Customer Portal | Support Cases | Create New Case | Invaid File Extention", {
            status: "Invalid File Extention",
            accountId: props.accountNumber,
          });
    } else {
      setFileExtensionModal(false);
    }
  }, [removableExtensionFiles]);

  useEffect(() => {
    let fileResponseReceived = [];
    if (fileStatusResponse.length) {
      fileStatusResponse.forEach((fStatus) =>
        fStatus.status === "fulfilled" ? fileResponseReceived.push("true") : fileResponseReceived.push("false")
      );
      setFileSuccessAndError([...fileResponseReceived]);
      if (props.addComments) {
        props.setAttachmentStatusResponse([...fileResponseReceived]);
      } else {
        props.setFileStatusResponse([...fileResponseReceived]);
      }
    }
  }, [fileStatusResponse]);

  useEffect(() => {
    if (fileInfos.length) {
      props.setAttachmentCheck(true);
      if (props.addComments === true) {
        props.setCommentAttachmentCheck(true);
        props.setIsResetAttachedFiles();
        handleFilePostData();
      }
    } else {
      props.setAttachmentCheck(false);
      props.setCommentAttachmentCheck(false);
      setCommentAllFilePostData([]);
    }
  }, [fileInfos]);

  const isValidFileType = (fileName) => {
    return validFilesList.some((ext) => fileName.toLowerCase().endsWith(ext.toLowerCase()));
  };

  const isValidFilename = (fileName) => FilenameRegex.test(fileName);

  const checkFileSizeAndUpload = (file) => {
    const fileSizeMB = file.size / 1000000;
    if (fileSizeMB <= 5) {
      handleFileToBeUploaded(file);
    } else {
      handleBigFileSize(file);
    }
  };

  const processSingleFile = (file) => {
    if (!file.name || file.name.length === 0) return;
    if (isValidFileType(file.name)) {
      if (isValidFilename(file.name)) {
        checkFileSizeAndUpload(file);
      } else {
        props.setFilesWithInvalidFilename(true);
      }
    } else {
      handleFileExtension(file);
    }
  };

  const handleFileUpload = (e) => {
    if (fileInfos.length > 9) {
      setIsFileLimitReached(true);
      trackFileLimitExceeded();
      return;
    }

    setFileSuccessAndError([]);
    const files = Array.from(e.target.files);
    e.target.value = null;

    const userUploadedFiles = [];
    files.forEach((file) => {
      const processedFile = handleFiles(file);
      userUploadedFiles.push(processedFile);
      processSingleFile(processedFile);
    });

    setTimeout(() => {
      if (userUploadedFiles.length) {
        filenameRef?.current?.focus();
      }
    });
  };

  const trackFileLimitExceeded = () => {
    const event = props.addComments
      ? "Customer Portal | Support Cases | Add Comments | Maximum 10 Files"
      : "Customer Portal | Support Cases | Create New Case | Maximum 10 Files";

    pendoTrack(event, {
      status: "More Than 10 Files Uploaded",
      accountId: props.accountNumber,
    });
  };

  const handleFileToBeUploaded = (files) => {
    if (FileCount <= 9) {
      FileCount = FileCount + 1;
      setFileInfos((current) => [...current.concat(files)]);
    } else {
      setIsFileLimitReached(true);
      props.addComments === true
        ? pendoTrack("Customer Portal | Support Cases | Add Comments | Maximum 10 Files", {
            status: "More Than 10 Files Uploaded",
            accountId: props.accountNumber,
          })
        : pendoTrack("Customer Portal | Support Cases | Create New Case | Maximum 10 Files", {
            status: "More Than 10 Files Uploaded",
            accountId: props.accountNumber,
          });
    }
  };

  const handleBigFileSize = (removeFile) => {
    setRemovableFiles((current) => [...current.concat(removeFile)]);
  };

  const handleFileExtension = (removeFile) => {
    setRemovableExtensionFiles((current) => [...current.concat(removeFile)]);
  };

  const handleFilePostData = async () => {
    if (fileInfos.length) {
      const postedFilesList = await buildPostFilesList(fileInfos);

      props.addComments ? setCommentAllFilePostData(postedFilesList) : setAllFilePostData(postedFilesList);
    } else if (!props.addComments) {
      await handleNoFileCreateCase();
    }
  };

  const buildPostFilesList = async (files) => {
    const list = [];

    for (const file of files) {
      const base64ConvertedFile = await convertBase64(file);
      const splitData = base64ConvertedFile.split(",");
      const fileTitle = handleGetOnlyFileName(file.name);
      const caseID = props.addComments ? props.commentCaseId : props.caseId;

      list.push({
        caseId: caseID,
        visibility: "AllUsers",
        title: file.name,
        fileName: fileTitle,
        isMajorVersion: "true",
        versionData: splitData[1],
      });
    }

    // update file name/attachment based on context
    props.addComments ? props.setAttachmentName(files) : props.setFileName(files);

    return list;
  };

  const handleNoFileCreateCase = async () => {
    props.setCreateCaseFieldsErr("newCaseErr", false);
    props.setCaseCreatedSuccess(true);

    await props.getAllCases();
    props.toggleCreateCase(false);

    setTimeout(() => {
      props.setCaseCreatedSuccess(false);
    }, 5000);
  };

  const handleFiles = (file) => {
    let generatedFileName = generateFileName(file.name);
    return new File([file], generatedFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  };

  const generateFileName = (fileName) => {
    let extension = fileName.split(".").pop();
    let [name] = fileName.split(".");
    let num = 0;
    let curName = `${name}.${extension}`;
    let exists = fileInfos.filter((f) => f.name === curName).length;
    while (exists) {
      curName = `${name}(${++num}).${extension}`;
      exists = fileInfos.filter((f) => f.name === curName).length;
    }
    return curName;
  };

  const handleGetOnlyFileName = (fileName) => {
    let lastDotPosition = fileName.lastIndexOf(".");
    if (lastDotPosition === -1) {
      return fileName;
    } else {
      return fileName.substr(0, lastDotPosition);
    }
  };

  const handleCommentAttachments = () => {
    props.setAttachmentsComment(commentAllFilePostData);
  };

  const handleGlobalCommentAttachments = async () => {
    const tasks = commentAllFilePostData.map(async (fData) => {
      await CaseAttachemntCall.postAnAttachmentCall(fData);
    });

    if (tasks.length !== 0) {
      props.setAttachmentLoader(true);
      props.setCommentsLoader(true);

      Promise.allSettled(tasks)
        .then(async (res) => {
          props.setLoader(false);
          props.setCommentsLoader(false);
          props.setDisableCommentCancel(true);
          setFileStatusResponse(res);
          handleCommentModalClose();
        })
        .catch(async (err) => {
          props.setLoader(false);
          props.setCommentsLoader(false);
          props.setDisableCommentCancel(true);
          setFileUploadFailedAlert(true);
          handleCommentModalClose();
          console.log("Error", err);
        });
    }
  };

  const handleCommentModalClose = async () => {
    FileCount = 0;
    setFileInfos([]);
    setRemovableFiles([]);
    setCommentAllFilePostData([]);
    props.reset();
    props.setCaseReplySuccess(true);
    props.setCommentsLoader(false);
    props.setSubmitCommentAttachment(false);
    props.getActivity();
    setTimeout(function () {
      props.setCaseReplySuccess(false);
    }, 5000);
    props.setSubmitAttachemnt(false);
  };

  const onClickOfCancel = () => {
    FileCount = 0;
    setFileInfos([]);
    setRemovableFiles([]);
    setCommentAllFilePostData([]);
    props.reset();
  };

  const handleGlobalAttachments = async () => {
    const tasks = allFilePostData.map((fData) => CaseAttachemntCall.postAnAttachmentCall(fData));

    if (tasks.length !== 0) {
      setAttachmentLoaderSmall(true);
      props.setAttachmentLoader(true);

      Promise.allSettled(tasks)
        .then(async (res) => {
          props.setLoader(false);
          setAttachmentLoaderSmall(false);
          props.setDisableFields(true);
          setFileStatusResponse(res);
          let fileResponseReceived = [];
          res.forEach((fStatus) => (fStatus.status === "fulfilled" ? fileResponseReceived.push("true") : fileResponseReceived.push("false")));
          props.setFileStatusResponse([...fileResponseReceived]);
          props.toggleCreateCase(false);
          handleModalClose();
        })
        .catch(async (err) => {
          props.setLoader(false);
          setAttachmentLoaderSmall(false);
          props.setDisableFields(true);
          setFileUploadFailedAlert(true);
          props.toggleCreateCase(false);
          handleModalClose();
          console.log("Error", err);
        });
    }
  };

  const handleModalClose = async () => {
    props.setCreateCaseFieldsErr("newCaseErr", false);
    props.setCaseCreatedSuccess(true);
    await props.getAllCases();
    setTimeout(function () {
      props.setCaseCreatedSuccess(false);
    }, 5000);
    props.setSubmitAttachemnt(false);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(new Error(error?.message || "File reading failed"));
      };
    });
  };

  const handleDeleteFilter = (fname) => {
    inputRef.current?.focus();
    const newList = fileInfos.filter((file) => file.name !== fname);
    FileCount = FileCount - 1;
    setFileInfos(newList);
    if (!newList.length) {
      inputRef.current.focus();
    } else {
      filenameRef.current.focus();
    }
  };

  const handleUnableToUploadModal = () => {
    setRemovableFiles([]);
    setModalClose(false);
  };

  const handleFileExtensionModal = () => {
    setRemovableExtensionFiles([]);
    setFileExtensionModal(false);
  };

  const handleMaximumLimitModal = () => {
    setIsFileLimitReached(false);
  };
  const clearFilenameError = () => props.setFilesWithInvalidFilename(false);

  const getResponsiveButtonWidth = (mobileWidth = "100%", defaultWidth = "5.813rem") => {
    const isTabletOrSmaller = props.windowSize.Width < TABLET;
    const isSpanish = userLanguage === "es-ES";
    const isTabletOrLarger = props.windowSize.Width >= TABLET;

    if (isTabletOrSmaller) {
      return mobileWidth;
    }
    if (isSpanish && isTabletOrLarger) {
      return "6.813rem";
    }
    return defaultWidth;
  };

  const getButtonWidth = () => getResponsiveButtonWidth("100%", "5.813rem");
  const okButtonWidth = () => getResponsiveButtonWidth("97%", "5.813rem");

  return (
    <div>
      {fileUploadFailedAlert && (
        <Notification
          type="error"
          title={t("Unable to upload, please try again.")}
          layout="vertical"
          onCloseButtonClick={() => {
            setFileUploadFailedAlert(false);
          }}
        />
      )}
      {modalClose && (
        <RedesignedModal
          opened={true}
          onClickClose={handleUnableToUploadModal}
          zIndex={"1001"}
          title={t("Maximum file size exceeded")}
          ModalAriaLabel="Cancel Unable To Upload Modal"
          isScrollable={true}
        >
          <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="6px" marginTop="0" lineHeight="20px">
            {t("The following files exceed the 5 MB limit:")}
          </TextWrapper>
          <Wrapper height={removableFiles.length > 3 && "10rem"} position="relative">
            {removableFiles.map((files, index) => (
              <div className="filesContainer" key={`${files.name}-${index}`} style={{ height: "auto", marginBottom: "0" }}>
                <TextWrapper
                  fontStyle="normal"
                  fontWeight="400"
                  fontSize="14px"
                  marginBottom="0"
                  marginTop="0"
                  padding="10px 0 0 0"
                  lineHeight="20px"
                >
                  {files.name}
                </TextWrapper>
              </div>
            ))}
            <ButtonWrapper>
              <CPButton
                id="maximum-file-size-ok-button"
                size="large"
                secondary={false}
                buttonWidth={getButtonWidth()}
                boxButton={true}
                fontSize="0.875rem"
                onClick={handleUnableToUploadModal}
              >
                {t(`OK`)}
              </CPButton>
            </ButtonWrapper>
          </Wrapper>
        </RedesignedModal>
      )}

      <RedesignedModal
        opened={fileExtensionModal}
        onClickClose={handleFileExtensionModal}
        zIndex={"1001"}
        isScrollable={true}
        title={t("Incorrect file type")}
        ModalAriaLabel="Unable To Upload File Extension"
      >
        <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="16px" marginTop="0" lineHeight="20px">
          {t("You can only upload supported file types: PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX, NOTEBOOK, JPG, JPEG, PNG.")}
        </TextWrapper>

        <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0" lineHeight="20px">
          {t("The following files cannot be uploaded:")}
        </TextWrapper>
        <Wrapper height={removableExtensionFiles.length > 3 && "10rem"} position="relative">
          {removableExtensionFiles.map((files, index) => (
            <div className="filesContainer" key={`${files.name}-${index}`} style={{ height: "auto", marginBottom: "0" }}>
              <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0" padding="10px 0 0 0" lineHeight="20px">
                {files.name}
              </TextWrapper>
            </div>
          ))}
          <ButtonWrapper>
            <CPButton
              id="invalid-file-extension-ok-button"
              size="large"
              boxButton={true}
              secondary={false}
              buttonWidth={okButtonWidth()}
              fontSize="0.875rem"
              onClick={handleFileExtensionModal}
            >
              {t(`OK`)}
            </CPButton>
          </ButtonWrapper>
        </Wrapper>
      </RedesignedModal>
      {isFileLimitReached && (
        <RedesignedModal
          opened={true}
          onClickClose={handleMaximumLimitModal}
          zIndex={"1001"}
          isScrollable={true}
          title={t("File limit reached")}
          ModalAriaLabel="File limit reached"
        >
          <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0" lineHeight="20px">
            {t("You have reached the maximum number of files that can be uploaded. You can upload a maximum of 10 files.")}
          </TextWrapper>
          <ButtonWrapper>
            <CPButton
              id="invalid-file-extension-ok-button"
              size="large"
              boxButton={true}
              secondary={false}
              fontSize="0.875rem"
              onClick={handleMaximumLimitModal}
              buttonWidth={okButtonWidth()}
            >
              {t(`OK`)}
            </CPButton>
          </ButtonWrapper>
        </RedesignedModal>
      )}

      <div>
        <div className="attachmentContainer_parent" style={{ "margin-top": "0" }}>
          <div
            style={{ width: props.disableInput && "100%" }}
            id={(() => {
              const langMap = {
                "fr-FR": "attachemntChild-1_fr",
                "de-DE": "attachemntChild-1_de",
                "nl-NL": "attachemntChild-1_nl",
              };
              return langMap[userLanguage] || "attachemntChild-1_en";
            })()}
          >
            {props.disableInput ? null : (
              <AttachmentInput
                userLanguage={userLanguage}
                reference={inputRef}
                upload={handleFileUpload}
                marginBottom={fileInfos.length === 0 ? "0" : props.marginBottom}
                disabled={props.requestClosure}
                clearFilenameError={clearFilenameError}
                attachLinkRef={attachLinkRef}
              />
            )}
            {props.addComments === true ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                {" "}
                {!props.commentsLoading &&
                  fileInfos.length !== 0 &&
                  fileInfos.map((file, index) => (
                    <Wrapper key={`${file.name}-${index}`} display="flex" gap="1rem">
                      <CustomisedTextLink
                        ref={index === fileInfos.length - 1 ? filenameRef : null}
                        tabIndex={-1}
                        type="standAlone"
                        size="large"
                        style={{ fontSize: "14px", fontFamily: "neue-haas-grotesk-text", overflowWrap: "anywhere" }}
                      >
                        {file.name}
                      </CustomisedTextLink>
                      <CPIcon
                        id="trash-icon"
                        type="trash"
                        tabIndex="0"
                        ariaLabel="trash icon"
                        clickHandler={() => {
                          handleDeleteFilter(file.name);
                        }}
                      />
                    </Wrapper>
                  ))}
              </div>
            ) : (
              <>
                {fileInfos.length !== 0 &&
                  fileInfos.map((file, index) => (
                    <div className="filesContainer" key={`${file.name}-${index}`} style={{ marginBottom: "0.35rem" }}>
                      <Body size="small" id="attachmentInfoList" width="100%">
                        {attachmentLoaderSmall && (
                          <CustomLoader className="smallLoaderContainer">
                            <Loader className="insideLoader" active={attachmentLoaderSmall} fullscreen={false}></Loader>
                          </CustomLoader>
                        )}
                        {(() => {
                          if (fileSuccessAndError.length === fileInfos.length) {
                            if (fileSuccessAndError[index] === "true") {
                              return <img className="fileResponseStyle" alt="tickMark" src={Tick}></img>;
                            } else {
                              return <img className="fileResponseStyle" alt="cautionMark" src={Caution}></img>;
                            }
                          } else {
                            return <span></span>;
                          }
                        })()}
                        <CustomisedFileNames fontSize={"14px"}>{file.name}</CustomisedFileNames>
                        {fileStatusResponse.length ? (
                          <span></span>
                        ) : (
                          <StyledRemoveIcon
                            id="file-remove-button"
                            alt="removeIcon"
                            src={DeleteIcon}
                            onClick={() => {
                              handleDeleteFilter(file.name);
                            }}
                          />
                        )}

                        {(() => {
                          let errorDisplay = <span></span>;
                          if (fileSuccessAndError.length === fileInfos.length) {
                            if (fileSuccessAndError[index] !== "true") {
                              errorDisplay = (
                                <span
                                  style={{
                                    marginLeft: "1.125rem",
                                    fontWeight: "bold",
                                    color: "coral",
                                  }}
                                >
                                  {t("Invalid file")}
                                </span>
                              );
                            }
                          }
                          return errorDisplay;
                        })()}
                      </Body>
                    </div>
                  ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleCreateCase: Actions.toggleCreateCase,
  setSubmitAttachemnt: CreateCaseActions.setSubmitAttachment,
  setAttachemntFileNameError: CreateCaseActions.setAttchmentErrorNotification,
  setAttachmentSizeError: CreateCaseActions.setAttachmentFileSizeError,
  setAttachmentLoader: CreateCaseActions.setAttachmentLoader,
  getAllCases: Actions.getAllCases,
  setCaseCreatedSuccess: Actions.setCaseCreatedSuccess,
  setCreateCaseFieldsErr: CreateCaseActions.setCreateCaseFieldsErr,
  setAttachmentCheck: CreateCaseActions.setAttachmentCheck,
  setLoader: CreateCaseActions.setLoader,
  setDisableFields: CreateCaseActions.setDisableFields,
  setFileStatusResponse: CreateCaseActions.setFileStatusResponse,
  setFileName: CreateCaseActions.setFileName,
  setAttachmentsComment: viewCaseDetailsActions.setAttachmentsComment,
  getAllViewCaseDetails: viewCaseDetailsActions.getAllViewCaseDetails,
  setCaseReplySuccess: viewCaseDetailsActions.setCaseReplySuccess,
  setCommentsLoader: viewCaseDetailsActions.setCommentsLoader,
  setSubmitCommentAttachment: viewCaseDetailsActions.setSubmitCommentAttachment,
  setDisableCommentCancel: viewCaseDetailsActions.setDisableCommentCancel,
  setCommentAttachmentCheck: viewCaseDetailsActions.setCommentAttachmentCheck,
  reset: viewCaseDetailsActions.resetAddComments,
  setAttachmentStatusResponse: viewCaseDetailsActions.setAttachmentStatusResponse,
  setAttachmentName: viewCaseDetailsActions.setAttachmentName,
  getActivity: viewCaseDetailsActions.getActivity,
};

const mapStateToProps = (state) => {
  return {
    createCaseToggle: state.CASELIST.createCaseToggle,
    handleAttachemntSubmit: state.CREATECASE.handleAttachemntSubmit,
    attachmentErrorNotification: state.CREATECASE.attachmentErrorNotification,
    caseId: state.CREATECASE.caseID,
    attachmentFileSizeError: state.CREATECASE.attachmentFileSizeError,
    attachmentLoader: state.CREATECASE.attachmentLoader,
    commentAttachmentError: state.VIEWCASEDETAILS.commentAttachmentError,
    commentAttachmentErrorMsg: state.VIEWCASEDETAILS.commentAttachmentErrorMsg,
    handleCommentAttachmentSubmit: state.VIEWCASEDETAILS.handleCommentAttachmentSubmit,
    windowSize: state.ACCOUNT.windowSize,
    accountNumber: state.ACCOUNT.accountNumber,
    commentsLoading: state.VIEWCASEDETAILS.commentsLoading,
    status: state.VIEWCASEDETAILS.status,
    requestClosure: state.VIEWCASEDETAILS.requestClosure,
  };
};

AddAttachmentImpl.propTypes = {
  addComments: PropTypes.bool,
  windowSize: PropTypes.shape({
    Width: PropTypes.number.isRequired,
  }).isRequired,
  accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setLoader: PropTypes.func,
  reset: PropTypes.func,
  isResetAttachedFiles: PropTypes.bool,
  handleAttachemntSubmit: PropTypes.bool,
  handleCommentAttachmentSubmit: PropTypes.bool,
  setAttachmentStatusResponse: PropTypes.func,
  setAttachmentCheck: PropTypes.func,
  setCommentAttachmentCheck: PropTypes.func,
  setIsResetAttachedFiles: PropTypes.func,
  commentCaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setAttachmentName: PropTypes.func,
  setFileName: PropTypes.func,
  setFileStatusResponse: PropTypes.func,
  setFilesWithInvalidFilename: PropTypes.func,
  setCreateCaseFieldsErr: PropTypes.func,
  setCaseCreatedSuccess: PropTypes.func,
  getAllCases: PropTypes.func,
  toggleCreateCase: PropTypes.func,
  setAttachmentsComment: PropTypes.func,
  setAttachmentLoader: PropTypes.func,
  setCommentsLoader: PropTypes.func,
  setCaseReplySuccess: PropTypes.func,
  getActivity: PropTypes.func,
  setDisableFields: PropTypes.func,
  setSubmitAttachemnt: PropTypes.func,
  setSubmitCommentAttachment: PropTypes.func,
  setDisableCommentCancel: PropTypes.func,
  commentsLoading: PropTypes.bool,
  requestClosure: PropTypes.bool,
  marginBottom: PropTypes.string,
  disableInput: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAttachmentImpl);
